import React, { useState, useEffect } from "react";
import moment from "moment";
import { useFieldArray } from "react-hook-form";
import { format } from 'date-fns';

const MeasurementsItems = (props) => {
    const [dataIndex, setDataIndex] = useState(false);
    const [which, setWhich] = useState(null);
    const control = props.control;
    const register = props.register;

    useEffect(() => {}, [dataIndex]);

    useEffect(() => {
        setWhich(props.which);
        (which === props.which && props.appendItem !== null && props.appendItem !== undefined) && addValue();
    }, [props.appendItem]);

    const { fields, remove, append } = useFieldArray({
        control,
        name: `process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`,
        key: "insertedDate"
    });

    useEffect(() => {}, [props.reloader]);

    useEffect(() => {
        if (props.editIndex) {
            if (fields[props.editIndex.index]) {
                fields[props.editIndex.index].insertedDate = props.editIndex.insertionDate;
            }
            const currentMeasures = props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`);
            if (Array.isArray(currentMeasures)) {
                currentMeasures.sort(compareDatesAsc);
            }
        }
    }, [props.refresh]);

    const startAt = (date) => {
        const parsed = format(date, 'yyyy-MM-dd HH:mm:00.000');
        return new Date(parsed);
    };

    const addValue = async () => {
        let fieldComment = await props.db.collection('measurement').doc(props.getValues(`id`)).collection('process').doc(props.getValues(`process[${props.nestIndex}].id`)).collection(`${props.which}Comments`)
            .where("insertedDate", ">=", startAt(props.appendItem.insertedDate))
            .where("insertedDate", "<", startAt((new Date(props.appendItem.insertedDate)).setMinutes((new Date(props.appendItem.insertedDate)).getMinutes() + 1)))
            .limit(1).get();

        let currentMeasures = props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`) || [];
        let same = currentMeasures.find((z) => z && z.insertedDate && moment(z.id === undefined ? z.insertedDate : (z.insertedDate.toDate ? z.insertedDate.toDate() : z.insertedDate)).isSame(props.appendItem.insertedDate, 'minute'));

        if (fieldComment.docs.length === 0 && same === undefined) append(props.appendItem);
    };

    const dateFormatter = (date) => {
        const formatStr = 'YYYY/MM/DD HH:mm';
        if (moment(date).isValid()) {
            return moment(date).format(formatStr);
        }
        if (date && date.toDate) {
            return moment(date.toDate()).format(formatStr);
        }
        return '';
    };

    function compareDatesAsc(a, b) {
        const dateA = dateFormatter(a.insertedDate);
        const dateB = dateFormatter(b.insertedDate);
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        return 0;
    }

    const currentMeasures = props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`);
    if (Array.isArray(currentMeasures)) {
        currentMeasures.sort(compareDatesAsc);
    }

    const handleToleranceColor = (value, lvlMin, lvlMax, rangeSettings) => {
        if (value === undefined || value === null || value === '') return '';
        let color = '';
        switch (rangeSettings) {
            case '上限下限共':
                color = (value * 1 >= lvlMin * 1 && value * 1 <= lvlMax * 1 ? '' : '#FF0000');
                break;
            case '下限のみ':
                color = (value * 1 >= lvlMin * 1 ? '' : '#FF0000');
                break;
            case '上限のみ':
                color = (value * 1 <= lvlMax * 1 ? '' : '#FF0000');
                break;
            default:
                color = (value * 1 >= lvlMin * 1 && value * 1 <= lvlMax * 1 ? '' : '#FF0000');
                break;
        }
        return color;
    };

    const uniqueTimestamps = props.uniqueTimestamps || [];
    const measuresArray = props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`) || [];

    return (
        uniqueTimestamps.map((ts) => {
            const matchIndex = measuresArray.findIndex(m => {
                if (!m || !m.insertedDate) return false;
                return props.dateFormatter(m.insertedDate) === ts.dateStr;
            });

            const hasRecord = matchIndex !== -1;
            const vl = hasRecord ? measuresArray[matchIndex] : null;
            const valStr = hasRecord ? String(props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure][${matchIndex}].value`) ?? '') : '';

            // If not in edit mode and cell has no record, render static "-"
            if (!props.editClicked && !hasRecord) {
                return (
                    <td key={ts.dateStr} style={{ textAlign: 'center', alignItems: 'center', backgroundColor: '#fafafa' }}>
                        <span style={{ color: '#ccc', fontSize: 13 }}>-</span>
                    </td>
                );
            }

            // In Edit mode OR if cell has a record: render editable input field
            return (
                <td key={ts.dateStr} style={{ textAlign: 'center', alignItems: 'center' }}>
                    <input
                        key={ts.dateStr}
                        step={'any'}
                        className={'form-control'}
                        autoFocus={false}
                        defaultValue={hasRecord ? valStr : undefined}
                        style={{
                            width: 60 + (valStr.length > 4 ? valStr.length : 0) * 5 + 'px',
                            borderWidth: !props.editClicked ? '0' : 'thin',
                            textAlign: 'center',
                            alignItems: 'center',
                            backgroundColor: !props.editClicked ? 'white' : (vl && vl.edit ? '#FFFDE8' : ''),
                            color: handleToleranceColor(
                                valStr,
                                props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}].tolerance_lvl_min`),
                                props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}].tolerance_lvl_max`),
                                props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}].range_settings`)
                            )
                        }}
                        disabled={!props.editClicked}
                        type="number"
                        {...(hasRecord ? register(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure][${matchIndex}].value`) : {})}
                        onChange={(e) => {
                            const newNumVal = e.target.value;
                            const currentList = props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure]`) || [];
                            const idxToUpdate = currentList.findIndex(m => m && m.insertedDate && props.dateFormatter(m.insertedDate) === ts.dateStr);

                            if (idxToUpdate !== -1) {
                                props.setValue(`process[${props.nestIndex}].items[${props.itemIndex}][${props.which}Measure][${idxToUpdate}]`, {
                                    ...currentList[idxToUpdate],
                                    value: newNumVal,
                                    edit: currentList[idxToUpdate].id === undefined ? false : true,
                                    changed: true,
                                });
                            } else {
                                // Cell was empty: Append new measure entry for this item & timestamp!
                                const newObj = {
                                    value: newNumVal,
                                    insertedDate: ts.rawDate,
                                    edit: false,
                                    changed: true,
                                    processId: props.getValues(`process[${props.nestIndex}].id`),
                                    itemsId: props.getValues(`process[${props.nestIndex}].items[${props.itemIndex}].id`)
                                };
                                append(newObj);
                            }
                            setDataIndex(!dataIndex);
                        }}
                    />
                </td>
            );
        })
    );
};

export default MeasurementsItems;
